<template>
  <div>
    <b-modal id="cookie-settings-modal" ref="cookieSettingsModal" :hide-header-close="true" hide-footer :no-close-on-backdrop="noCloseOnBackdrop">
      <template slot="modal-title">
        <div class="row">
          <span class="header-text col-9">We Value Your Privacy</span>
          <i class="fa fa-times col-3 text-right close-modal-btn" aria-hidden="true" @click="hide('close-modal')"></i>
        </div>
      </template>
      <div class="row pb-32">
        <span class="privacy-text"> We use cookies to operate this website, enhance usability, and to analyze performance and traffic on the THREAD platform. Your privacy is important to us, and we will never sell your data. <router-link :to="{ name: 'privacy-policy' }" target="_blank">Privacy Policy</router-link> </span>
      </div>
      <div class="row footer-buttons text-right">
        <div class="col-md-12 col-xs-12 pr-0 footer-btn-wrap">
          <b-button variant="outline-primary" class="manage-cookies-btn" @click="openManageCookieModal()">Manage Cookie Preferences</b-button>
          <b-button variant="primary" class="accept-cookies-btn" @click="saveCookieSettings()">Accept All Cookies</b-button>
        </div>
      </div>
    </b-modal>
    <manageCookiesModal ref="manageCookiesModal" :platformType="platformType"></manageCookiesModal>
  </div>
</template>

<script>
import manageCookiesModal from "@/components/auth/manage-cookies.vue";
import * as authService from "@/components/services/auth-service";
export default {
  name: "cookie-settings-modal",
  components: {
    manageCookiesModal
  },
  props: {
    //This can be either portal or pweb
    platformType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      noCloseOnBackdrop: true,
      isCookiesAccepted: false
    };
  },
  methods: {
    show() {
      this.$refs.cookieSettingsModal.show();
    },
    hide() {
      this.$refs.cookieSettingsModal.hide();
      if (!this.isCookiesAccepted) {
        authService.setNecessaryCookies(this.platformType);
      }
    },
    openManageCookieModal() {
      this.$refs.manageCookiesModal.show();
    },
    saveCookieSettings() {
      if (!this.isCookiesAccepted) {
        authService.setNecessaryCookies(this.platformType);
      }
      this.hide();
    }
  },
  mounted() {
    this.isCookiesAccepted = authService.getCookiePreference(this.platformType);
    this.$root.$on("showCookieBanner", data => {
      if (data === true) {
        this.$refs.cookieSettingsModal.show();
      }
    });
  }
};
</script>

<style lang="scss">
#cookie-settings-modal {
  .modal-dialog {
    width: 600px;
    max-width: 700px !important;
    position: absolute;
    bottom: 0;
    margin-bottom: 0px;
    left: 0;
    right: 0;

    .modal-header {
      border-bottom: 0;
      padding-left: 15px !important;
    }

    .modal-title {
      width: 100%;

      .close-modal-btn {
        padding-right: 0px;
        cursor: pointer;
      }
    }

    .modal-content {
      padding: 14px 25px 25px 25px;

      .header-text {
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666669;
        padding-left: 0px;
      }

      .privacy-text {
        font-size: 14px;
        line-height: 1.14;
        color: #666669;
      }

      .manage-cookies-btn {
        padding: 8px 16px;
        border: solid 1px #4c8ce4;

        &:hover {
          color: #007bff;
          background-color: transparent;
          border-color: #007bff;
        }
      }
      .accept-cookies-btn {
        padding: 8px 16px;
        border-radius: 4px;
        background-color: #4c8ce4;
        margin-left: 12px;
      }
    }
  }
}

/* Mobile View  */
@media (max-width: 560px) {
  #cookie-settings-modal {
    .modal-dialog {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin-bottom: 0px;
      width: auto;
      min-width: 300px !important;

      .footer-buttons {
        text-align: center !important;

        .footer-btn-wrap {
          padding-left: 0px;
          padding-right: 0px;
        }

        .manage-cookies-btn {
          margin-bottom: 12px;
          width: 275px;
        }
        .accept-cookies-btn {
          width: 275px;
          margin-left: 0px;
        }
      }

      .modal-content {
        .header-text {
          font-size: 20px;
          padding-right: 0px;
        }
      }
    }
  }
}
@media (max-width: 370px) {
  .manage-cookies-btn {
    width: 100% !important;
  }
  .accept-cookies-btn {
    width: 100% !important;
  }
}
</style>
